import { Ref, onMounted, onBeforeUnmount } from 'vue';

export const useClickOutside = (
  targetRef: Ref,
  callback: (e: Event) => void,
) => {
  if (!targetRef) return;

  const listener = (e: any) => {
    if (
      e.target == targetRef.value ||
      e.composedPath().includes(targetRef.value)
    ) {
      return;
    } else {
      callback(e);
    }
  };

  onMounted(() => {
    window.addEventListener('click', listener);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('click', listener);
  });

  return {
    listener,
  };
};
